/**
 * @license Copyright (c) 2003-2026, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

/**
 * @module list/legacylistproperties
 */

import { Plugin, type PluginDependenciesOf } from '@ckeditor/ckeditor5-core';
import { LegacyListPropertiesEditing } from './legacylistproperties/legacylistpropertiesediting.js';
import { ListPropertiesUI } from './listproperties/listpropertiesui.js';

/**
 * The legacy list properties feature.
 *
 * This is a "glue" plugin that loads the {@link module:list/legacylistproperties/legacylistpropertiesediting~LegacyListPropertiesEditing
 * legacy list properties editing feature} and the
 * {@link module:list/listproperties/listpropertiesui~ListPropertiesUI list properties UI feature}.
 */
export class LegacyListProperties extends Plugin {
	/**
	 * @inheritDoc
	 */
	public static get requires(): PluginDependenciesOf<[ LegacyListPropertiesEditing, ListPropertiesUI ]> {
		return [ LegacyListPropertiesEditing, ListPropertiesUI ];
	}

	/**
	 * @inheritDoc
	 */
	public static get pluginName() {
		return 'LegacyListProperties' as const;
	}

	/**
	 * @inheritDoc
	 */
	public static override get isOfficialPlugin(): true {
		return true;
	}
}
